import React from 'react'
// @ts-ignore no types
import { Icon } from '@adc/ui-morpheus'
// @ts-ignore no types
import { BaseCell } from '@adc/datatable'

const BASE_ELM_ID = 'row'

interface DrawerCellProps {
  value: Record<string, unknown>
  rowIndex: number
  classes?: string[]
  onClick: (value: Record<string, unknown>) => void
  [key: string]: unknown
}

const DrawerCell: React.FC<DrawerCellProps> = ({
  value,
  rowIndex,
  classes,
  onClick,
  ...rest
}) => {
  return (
    <BaseCell {...rest}>
      <div
        style={{ cursor: 'pointer' }}
        data-elm-id={`${BASE_ELM_ID}_${rowIndex}_open_button`}
        onClick={() => onClick(value)}
        role='secondary'
      >
        <Icon name='pencil' color='info' size='large' fitted />
      </div>
    </BaseCell>
  )
}

export default DrawerCell
